import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Container from '~/layout/Container';
import Row from '~/layout/Row';
import Column from '~/layout/Column';

import SocialLinks from '~/components/SocialLinks';
import EmphasisGravityForm from '~/components/EmphasisGravityForm';
import NavItems from '~/components/footer/NavItems';

import { NavHeaderFont } from '~/components/footer/NavItems';

import { Hiddenh2, Hiddenh3 } from '~/styles/helpers';

const NavWrapper = styled.footer`
    background-color: ${({ theme }) => theme.colors.accent.blue};
    font-family: ${({ theme }) => theme.fonts.heading};
    padding: 20px 0;

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        padding: 70px 0 125px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        padding: 70px 0 250px;
    }
`;

const Nav = styled.nav`
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        display: block;
    }
`;

const NavList = styled.ul`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
`;

const Centered = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
`;

const FooterSubscribeTitle = styled.h3`
    ${NavHeaderFont};
`;

const SocialLinksWrapper = styled.div`
    margin-top: 30px;
`;

const FooterNavigation = ({ data }) => {
    const {
        allWpMenuItem: menuItems,
        wp: {
            siteSettings: {
                siteSettings: { subscribeFormId, appLinks, socialLinks }
            }
        }
    } = data;

    return (
        <NavWrapper>
            <Hiddenh2 id="footerLabel">Footer</Hiddenh2>
            <Container>
                <Row rowGapPhone="sectionPaddingSmall">
                    {menuItems?.nodes?.length ? (
                        <Column spanLargeTablet={8} span={12}>
                            <Nav aria-label="Footer Links">
                                <Hiddenh3 id="footerNavigationLabel">
                                    Footer Navigation
                                </Hiddenh3>
                                <NavList aria-labelledby="footerNavigationLabel">
                                    <NavItems {...{ menuItems, appLinks }} />
                                </NavList>
                            </Nav>
                        </Column>
                    ) : null}
                    {subscribeFormId || socialLinks?.length ? (
                        <Column
                            spanLargeTablet={4}
                            spanTablet={6}
                            startTablet={4}
                            span={12}
                        >
                            <Centered>
                                {subscribeFormId && (
                                    <>
                                        <FooterSubscribeTitle>
                                            Sign Up for Our Newsletter
                                        </FooterSubscribeTitle>
                                        <EmphasisGravityForm
                                            reverse={true}
                                            formId={subscribeFormId}
                                            size="large"
                                        />
                                    </>
                                )}
                                {socialLinks?.length ? (
                                    <SocialLinksWrapper>
                                        <Hiddenh3 id="socialMediaLabel">
                                            Social Media
                                        </Hiddenh3>
                                        <SocialLinks
                                            socialAccounts={socialLinks}
                                            color="white"
                                            size={27}
                                            ariaLabelledBy="socialMediaLabel"
                                            role="list"
                                        />
                                    </SocialLinksWrapper>
                                ) : null}
                            </Centered>
                        </Column>
                    ) : null}
                </Row>
            </Container>
        </NavWrapper>
    );
};

FooterNavigation.propTypes = {
    data: PropTypes.object.isRequired
};

export default FooterNavigation;

export const query = graphql`
    query Footer {
        wp {
            siteSettings {
                siteSettings {
                    subscribeFormId
                    appLinks {
                        linkUrl
                        badge {
                            altText
                            sourceUrl
                            localFile {
                                childImageSharp {
                                    gatsbyImageData(aspectRatio: 3.09)
                                }
                            }
                        }
                    }
                    socialLinks {
                        linkUrl
                        iconClass
                    }
                }
            }
        }
        allWpMenuItem(
            filter: {
                locations: { eq: FOOTER_MENU }
                parentDatabaseId: { eq: 0 }
            }
            sort: { order: ASC }
        ) {
            nodes {
                url
                label
                id
                childItems {
                    nodes {
                        url
                        label
                        id
                    }
                }
            }
        }
    }
`;
